module.exports = __webpack_public_path__ + "static/media/second.6f88083f.gif";